exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-group-item.striped:nth-child(odd) {\n  background-color: rgba(0,0,0,0.02);\n}\n\n.padding-md {\n  padding: 3px 15px;\n}\n\n.margin-right-slim {\n  margin-right: 5px;\n}\n\n.col-rating {\n  width: 6.33%;\n}\n\n.col-button {\n  width: 18.66%;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/modules/thesis/thesis-overview/thesis-overview.component.css
// module id = ../../../../../src/app/modules/thesis/thesis-overview/thesis-overview.component.css
// module chunks = main